export default __webpack_public_path__ + "static/media/14-CathedralOfTheDonut.3288b7c0.png";